'use client';

import { VpButton, VpIcon } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { getLogoutUri } from '@/app/actions/server';
import { ErrorInfos } from '@/app/components/Error/ErrorInfos';
import { useApiErrorContext } from '@/app/components/Provider';
import { GenericDialog } from '~/components/commons/genericDialog/GenericDialog';
import { UserPageHeader } from '~/components/commons/UserPage/UserPageHeader';
import { DeleteAccountDialog } from './DeleteAccountDialog';
import { SendPersonalData } from './SendPersonalData';

export const PersonalData = () => {
  const tPersonalData = useTranslations('SETTINGS.PERSONAL_DATA');
  const tGlobal = useTranslations('GLOBAL');

  const { error, setError } = useApiErrorContext();

  const [isDeleteAccountDialogOpened, setIsDeleteAccountDialogOpened]
    = useState(false);
  const [isDeletionConfirmed, setIsDeletionConfirmed] = useState(false);

  const handleLogout = async () => {
    await getLogoutUri({});
  };

  return (
    <div
      data-testid="personal-data"
      className="personal-data"
    >
      <UserPageHeader title={(
        <span>
          {tPersonalData('TITLE')}
        </span>
      )}
      />
      {isDeletionConfirmed
        ? (
            <section className="personal-data__section">
              <p>
                {tPersonalData('DELETE_ACCOUNT.CONFIRMATION')}
              </p>
              <div>
                <VpButton
                  data-testid="logout"
                  variant="secondary"
                  startSlot={<VpIcon name="power" />}
                  id="logout"
                  onClick={handleLogout}
                >
                  {tGlobal('LOGOUT_2')}
                </VpButton>
              </div>
            </section>
          )
        : (
            <>
              <div className="profile__fieldgroup">
                <div className="profile__field profile__field--m">
                  <div className="personal-data__section__header">
                    <h2 className="vp-title-s">
                      {tPersonalData('REQUEST.TITLE')}
                    </h2>
                    <p className="vp-body-s">
                      {tPersonalData('REQUEST.SUBTITLE')}
                    </p>
                  </div>
                  <SendPersonalData />
                </div>
              </div>
              <div className="profile__fieldgroup">
                <div className="profile__field profile__field--m">
                  <div className="personal-data__section__header">
                    <h2 className="vp-title-s">
                      {tPersonalData('DELETE_ACCOUNT.TITLE')}
                    </h2>
                    <p className="vp-body-s">
                      {tPersonalData('DELETE_ACCOUNT.SUBTITLE')}
                    </p>
                  </div>
                  <div>
                    <VpButton
                      data-testid="openDialogDelete"
                      variant="secondary"
                      id="delete"
                      onClick={() => {
                        setIsDeleteAccountDialogOpened(true);
                      }}
                    >
                      {tPersonalData('DELETE_ACCOUNT.ACTION')}
                    </VpButton>
                  </div>
                  <DeleteAccountDialog
                    isOpen={isDeleteAccountDialogOpened}
                    setIsOpen={setIsDeleteAccountDialogOpened}
                    setIsDeletionConfirmed={setIsDeletionConfirmed}
                  />
                </div>
              </div>
            </>
          )}
      {error && <GenericDialog content={<ErrorInfos />} isOpen onClose={() => setError(null)} />}
    </div>
  );
};
